export const TradesmanTerms = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-background text-foreground">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Terms of Service for Tradespeople</h1>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Company:</strong> Realise Property Maintenance Ltd. trading as "Sortable"
        </p>
        <p className="text-sm text-muted-foreground mb-2">
          <strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          <strong>Telephone:</strong> 08000438880
        </p>
        <p className="text-sm text-muted-foreground">
          <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
        </p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl font-semibold mb-3">1. Professional Requirements</h2>
          <div className="space-y-2">
            <p>1.1. You must possess appropriate qualifications for the services you offer</p>
            <p>1.2. You must maintain valid public liability insurance (minimum £2 million)</p>
            <p>1.3. You must hold relevant trade certifications and licenses</p>
            <p>1.4. You must comply with all applicable health and safety regulations</p>
            <p>1.5. You must provide proof of identity and right to work in the UK</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">2. Profile and Verification</h2>
          <div className="space-y-2">
            <p>2.1. All information in your profile must be accurate and up-to-date</p>
            <p>2.2. You must upload genuine photos of your work and qualifications</p>
            <p>2.3. We reserve the right to verify your credentials and qualifications</p>
            <p>2.4. You must notify us immediately of any changes to your insurance or certifications</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">3. Job Bidding and Acceptance</h2>
          <div className="space-y-2">
            <p>3.1. You may submit quotes for jobs within your area of expertise</p>
            <p>3.2. All quotes must be realistic and based on the job requirements</p>
            <p>3.3. Once a quote is accepted, you are committed to completing the work</p>
            <p>3.4. You must respond to customer inquiries within 24 hours</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">4. Work Standards</h2>
          <div className="space-y-2">
            <p>4.1. All work must be completed to professional trade standards</p>
            <p>4.2. You must use appropriate materials and follow industry best practices</p>
            <p>4.3. You must complete work within agreed timeframes</p>
            <p>4.4. You must clean up after completing work</p>
            <p>4.5. You must provide warranties as required by law or agreed with the customer</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">5. Health and Safety</h2>
          <div className="space-y-2">
            <p>5.1. You must conduct risk assessments for all jobs</p>
            <p>5.2. You must use appropriate personal protective equipment</p>
            <p>5.3. You must follow Construction (Design and Management) Regulations where applicable</p>
            <p>5.4. You must report any accidents or incidents immediately</p>
            <p>5.5. You must ensure customer and public safety at all times</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">6. Payment Terms</h2>
          <div className="space-y-2">
            <p>6.1. Payment arrangements are made directly between you and the customer</p>
            <p>6.2. We may charge a service fee for each completed job</p>
            <p>6.3. You must issue invoices in accordance with HMRC requirements</p>
            <p>6.4. You are responsible for your own tax obligations</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">7. Customer Relations</h2>
          <div className="space-y-2">
            <p>7.1. You must treat all customers with respect and professionalism</p>
            <p>7.2. You must maintain customer confidentiality</p>
            <p>7.3. You must handle complaints promptly and professionally</p>
            <p>7.4. You must not engage in any form of discrimination or harassment</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">8. Prohibited Activities</h2>
          <div className="space-y-2">
            <p>8.1. Soliciting customers to work outside the platform</p>
            <p>8.2. Providing false or misleading information</p>
            <p>8.3. Subcontracting work without disclosure</p>
            <p>8.4. Engaging in any illegal or unethical practices</p>
            <p>8.5. Harassment or inappropriate behavior toward customers</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">9. Data Protection</h2>
          <div className="space-y-2">
            <p>9.1. You must comply with GDPR and data protection laws</p>
            <p>9.2. Customer personal information must be kept confidential</p>
            <p>9.3. You may only use customer data for the purpose of providing services</p>
            <p>9.4. You must securely dispose of any customer information after job completion</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">10. Dispute Resolution</h2>
          <div className="space-y-2">
            <p>10.1. We provide a dispute resolution service for customer complaints</p>
            <p>10.2. You must cooperate fully with any dispute resolution process</p>
            <p>10.3. Serious or repeated complaints may result in account suspension</p>
            <p>10.4. We may require remedial work or compensation for valid complaints</p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">11. Account Suspension</h2>
          <p className="mb-3">
            We may suspend or terminate your account for violations of these terms, 
            including but not limited to poor work quality, customer complaints, 
            safety violations, or fraudulent activity.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3">12. Contact Information</h2>
          <div className="space-y-2">
            <p>For questions about these terms, please contact us:</p>
            <p><strong>Email:</strong> tradesmen@sortable.co.uk</p>
            <p><strong>Phone:</strong> 08000438880</p>
            <p><strong>Address:</strong> 13 Harbury Rd. Henleaze Business Centre, Henleaze, Bristol, BS9 4PN</p>
          </div>
        </section>
      </div>
    </div>
  );
};